import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { NOnetrust } from './onetrust.interfaces';
import { OneTrustService } from './onetrust.service';

export function provideDfModuleOneTrust(config?: DeepPartial<NOnetrust.IModuleOptions>): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: NOnetrust.OPTIONS,
            useFactory: () => {
                return defaultsDeep(config, NOnetrust.defaultOptions);
            }
        },
        provideAppInitializer(() => {
            inject(OneTrustService).appInitialize();
        })
    ]);
}
